"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _ButtonGroup = require("../ButtonGroup/ButtonGroup.context");
var _VisuallyHidden = require("../VisuallyHidden/VisuallyHidden");
var _IconButton = require("./IconButton.styles");
var _excluded = ["appearance", "as", "buttonType", "children", "icon", "bare", "size", "title"];
/**
 * This is a icon-only button. It supports different types, different shapes and
 * a few helpers to allow you to have different asthetic variances to fit your needs.
 *
 * @related ['Icon']
 * @since 8.42.0
 */
var IconButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var appearance = _ref.appearance,
    as = _ref.as,
    buttonType = _ref.buttonType,
    children = _ref.children,
    icon = _ref.icon,
    bare = _ref.bare,
    size = _ref.size,
    title = _ref.title,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_ButtonGroup.ButtonGroupContext);
  var buttonProps = Object.assign({
    as: as,
    appearance: appearance,
    buttonType: context.buttonType || buttonType,
    size: context.size || size,
    bare: bare,
    ref: forwardedRef
  }, rest);

  // Inputs do not allow icon children
  if (as === 'input') {
    return /*#__PURE__*/_react.default.createElement(_IconButton.StyledIconButton, buttonProps, title);
  }
  return /*#__PURE__*/_react.default.createElement(_IconButton.StyledIconButton, buttonProps, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, null, title), /*#__PURE__*/_react.default.createElement("span", null, icon));
});
exports.IconButton = IconButton;
IconButton.displayName = 'IconButton';
IconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Use the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * to change the HTML tag of the component.
   *
   * This can be used to apply `Button` styling to HTML anchors, inputs, and custom components.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any,
  /**
   * The type of the button.
   * Can be inherited from a parent ButtonGroup.
   */
  buttonType: _propTypes.default.oneOf(Object.values(_constants.BUTTON_TYPES)),
  /**
   * Dictates the shape of the button [circle, square]
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.BUTTON_SHAPES)),
  /**
   * Set the button as disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * Add an `Icon` to the button.
   * _Note_ that the Icon size cannot and should not
   * be overwritten.
   */
  icon: _propTypes.default.node.isRequired,
  /**
   * Inverse colors for use on dark or colored backgrounds.
   */
  inverse: _propTypes.default.bool,
  /**
   * This removes the border on the button along with adding a transparent
   * background when the button is in the default state. Still retaining the default
   * background colors for hover, focus, and active.
   */
  bare: _propTypes.default.bool,
  /**
   * The size of the button.
   * Can be inherited from a parent ButtonGroup.
   */
  size: _propTypes.default.oneOf(Object.values(_constants.BUTTON_SIZES)),
  /**
   * Accessible text of the button
   */
  title: _propTypes.default.string.isRequired
} : {};
IconButton.defaultProps = {
  as: 'button',
  buttonType: _constants.BUTTON_TYPES.tertiary,
  appearance: _constants.BUTTON_SHAPES.square,
  disabled: undefined,
  inverse: false,
  bare: false,
  size: _constants.BUTTON_SIZES.md
};